import script from "./DateRangeInput.vue?vue&type=script&setup=true&lang=js"
export * from "./DateRangeInput.vue?vue&type=script&setup=true&lang=js"

import "./DateRangeInput.vue?vue&type=style&index=0&id=610a57d3&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-610a57d3"]])

export default __exports__